import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Modal, Button} from 'semantic-ui-react';
import {Actions} from '../../../../common/actions';

class PrintModal extends Component {
  constructor(props) {
    super(props);
    this.handleClose = this.handleClose.bind(this);
    this.handlePrintClick = this.handlePrintClick.bind(this);
  }

  handleClose() {
    this.props.clearLocationsToPrint();
  }

  handlePrintClick() {
    this.props.printCreatedLocations(this.props.locationsToPrint);
  }

  render() {
    const {trigger, isOpen, locationsToPrint} = this.props;

    return (
      <Modal
        trigger={trigger}
        open={isOpen}
        onClose={this.handleClose}
        size='small'
      >
        <Modal.Header>Confirmación</Modal.Header>
        <Modal.Content>
          <h3>¿Desea imprimir las etiquetas creadas ({locationsToPrint.length})?</h3>
        </Modal.Content>
        <Modal.Actions>
          <Button inverted secondary onClick={this.handleClose}>Cancelar</Button>
          <Button inverted primary onClick={this.handlePrintClick}>Aceptar</Button>
        </Modal.Actions>
      </Modal>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    'locationsToPrint': state.warehouseLocation.locationsToPrint,
  };
};

const {
  clearLocationsToPrint,
  printCreatedLocations,
} = Actions;

export default connect(mapStateToProps, {
  clearLocationsToPrint,
  printCreatedLocations,
})(PrintModal);
